export default {"src":"/_next/static/media/checkMarkIcon.8400eef3.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};